import { __localesModel, __localizedField } from "@/Utils/locales";
export const models = {
  locales: __localesModel,
  media: [],
  business_id: null,
  menu_id: null,
  parent_id: null
};
export const options = {
  parent_idOptions: []
};

export const Fields = [
  __localizedField,
  {
    type: "select",
    name: "parent_id",
    label: "Parent category",
    value: "",
    rules: "required",
    options: [],
    validationMessage: {
      required: "Select type please"
    },
    xl: "12"
  },
  {
    label: "Logo",
    name: "media",
    placeholder: "Choose image",
    type: "file",
    multiple: false,
    value: "",
    bodyClasses: "single-image",
    validationMessage: {
      required: "This field is required"
    },
    xl: "12"
  }
];
